<div class="modal-header">
  <h5 class="modal-title">{{ 'PUNCHOUT_AUDIT_ENTRY' | translate }}</h5>
  <button type="button" class="btn-close" (click)="close()" [attr.aria-label]="'CLOSE' | translate"></button>
</div>

<div class="modal-body">
  <dl class="row mb-0 punchout-audit-meta">
    <dt class="col-sm-3">{{ 'TIMESTAMP' | translate }}</dt>
    <dd class="col-sm-9">{{ entry.timestamp | date: 'yyyy-MM-dd HH:mm:ss' }}</dd>

    <dt class="col-sm-3">{{ 'TYPE' | translate }}</dt>
    <dd class="col-sm-9">{{ entry.type || 'PUNCHOUT_ORDER_MESSAGE' }}</dd>

    @if (entry.status) {
      <dt class="col-sm-3">{{ 'STATUS' | translate }}</dt>
      <dd class="col-sm-9">
        <span class="badge" [ngClass]="statusClass">{{ entry.status | translate }}</span>
      </dd>
    }

    <dt class="col-sm-3">{{ 'PUNCHOUT_CONFIG' | translate }}</dt>
    <dd class="col-sm-9">
      {{ configLabel || entry.customerConfigQualifier || entry.customerConfigId || '-' }}
      @if (entry.customerConfigQualifier) {
        <span class="text-muted"> ({{ entry.customerConfigQualifier }})</span>
      }
    </dd>

    @if (entry.username) {
      <dt class="col-sm-3">{{ 'USER' | translate }}</dt>
      <dd class="col-sm-9">{{ entry.username }}</dd>
    }

    @if (entry.protocol) {
      <dt class="col-sm-3">{{ 'PROTOCOL' | translate }}</dt>
      <dd class="col-sm-9">{{ entry.protocol | uppercase }}</dd>
    }

    @if (entry.metadata?.currency) {
      <dt class="col-sm-3">{{ 'CURRENCY' | translate }}</dt>
      <dd class="col-sm-9">{{ entry.metadata.currency }}</dd>
    }

    @if (entry.hookUrl) {
      <dt class="col-sm-3">{{ 'PUNCHOUT_HOOK_URL' | translate }}</dt>
      <dd class="col-sm-9">
        <code class="text-break">{{ entry.hookUrl }}</code>
      </dd>
    }

    @if (entry.target) {
      <dt class="col-sm-3">{{ 'TARGET' | translate }}</dt>
      <dd class="col-sm-9">
        <code class="text-break">{{ entry.target }}</code>
      </dd>
    }

    @if (entry.payloadId) {
      <dt class="col-sm-3">{{ 'PUNCHOUT_PAYLOAD_ID' | translate }}</dt>
      <dd class="col-sm-9">
        <code class="text-break">{{ entry.payloadId }}</code>
      </dd>
    }

    @if (entry.source) {
      <dt class="col-sm-3">{{ 'SOURCE' | translate }}</dt>
      <dd class="col-sm-9">{{ entry.source }}</dd>
    }

    @if (entry.ediMessageId) {
      <dt class="col-sm-3">{{ 'PUNCHOUT_EDI_MESSAGE' | translate }}</dt>
      <dd class="col-sm-9">
        @if (ediEnabled) {
          <a [routerLink]="['/admin/edi/orders', entry.ediMessageId]" (click)="close()">
            {{ entry.ediMessageId }}
          </a>
        } @else {
          <code class="text-break">{{ entry.ediMessageId }}</code>
        }
      </dd>
    }

    @if (failureCode) {
      <dt class="col-sm-3">{{ 'PUNCHOUT_FAILURE_CODE' | translate }}</dt>
      <dd class="col-sm-9 text-danger">
        <code class="text-break">{{ failureCode }}</code>
      </dd>
    }

    @if (entry.errorMessage) {
      <dt class="col-sm-3">{{ 'ERROR' | translate }}</dt>
      <dd class="col-sm-9 text-danger">{{ entry.errorMessage }}</dd>
    }
  </dl>

  @if (sections.length > 0) {
    <hr />
  }

  @for (section of sections; track section.labelKey) {
    <div class="mb-2">
      <div class="d-flex justify-content-between align-items-center">
        <button type="button" class="btn btn-link p-0 text-decoration-none" (click)="toggle(section)">
          <i class="fa-solid me-2" [ngClass]="expanded[section.labelKey] ? 'fa-chevron-down' : 'fa-chevron-right'"></i>
          <span>{{ section.labelKey | translate }}</span>
        </button>
        <button type="button" class="btn btn-sm btn-outline-secondary" (click)="copy(section)">
          <i class="fa-solid fa-copy me-1"></i>
          <span>{{ 'COPY' | translate }}</span>
        </button>
      </div>
      @if (expanded[section.labelKey]) {
        <pre class="punchout-audit-payload">{{ textOf(section) }}</pre>
      }
    </div>
  }

  @if (sections.length === 0) {
    <div class="text-center text-muted py-3">{{ 'PUNCHOUT_AUDIT_NO_PAYLOAD' | translate }}</div>
  }
</div>

<div class="modal-footer">
  @if (canReprocess) {
    <button type="button" class="btn btn-outline-primary me-auto" [disabled]="reprocessing" (click)="reprocess($event)">
      <i class="fa-solid fa-rotate-right me-1"></i>
      <span>{{ 'PUNCHOUT_REPROCESS' | translate }}</span>
    </button>
  }
  <button type="button" class="btn btn-secondary" (click)="close()">
    <span>{{ 'CLOSE' | translate }}</span>
  </button>
</div>
